module.exports = __webpack_public_path__ + "img/main-logos.802d24c7.png";